// extracted by mini-css-extract-plugin
export default {"container":"wP-z","topReviewHeading":"xP-z","criticalReview":"yP-z","favorableReview":"zP-z","vsSeparator":"AP-z"};